import FeaturesItem from '../components/features-item'
import Grid from '../components/grid'
import Container from '../components/ui/container'
import Text from '../components/ui/text'
import { CMSLink } from '../v2/components/CMSLink'
import { Page } from '@telesoft/types/payload-types'
import React, { ReactElement } from 'react'

export type FeaturedLinkGridProps = Extract<Page['blocks'][0], { blockType: 'feature-link-grid' }>

export default function FeatureLinkGrid(block: FeaturedLinkGridProps): ReactElement {
  const { gridLink, title, subTitle, features, hasLink } = block
  const link = gridLink?.link
  const isButton = hasLink
  const isSubtitle = subTitle && subTitle?.length > 0

  return (
    <Container>
      <Grid>
        <div className="col-span-full">
          <Text variant="subHeading" className="text-black max-w-2xl">
            {title}
          </Text>
        </div>

        {isSubtitle ||
          (isButton && (
            <div className="hidden col-span-full md:block lg:col-span-4 border-t border-telesoft pt-8">
              {isSubtitle && (
                <Text variant="heading" className="font-medium text-heading">
                  {subTitle}
                </Text>
              )}

              {isButton && <CMSLink {...link} className="w-full mt-6" />}
            </div>
          ))}
        {features?.map((feature: any, i: number) => {
          return <FeaturesItem key={`feature-grid-map--${i}`} feature={feature} />
        })}
      </Grid>
    </Container>
  )
}
